import { render, staticRenderFns } from "./SaleAgent.vue?vue&type=template&id=1d5b21d8"
import script from "./SaleAgent.vue?vue&type=script&lang=js"
export * from "./SaleAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports